<!------------------------------------------------------------------------------
 File: CouponCreate 
 Created by Keni Williams <kenneth.williams@estuk.co.uk>.
 with: IntelliJ IDEA
 Date: 2019-03-07
 Time: 13:43
------------------------------------------------------------------------------->
<template>
    <div>
        <form ref='coupon_form'
              :method="form.method"
              :action="form.action"
        >
            <input type="hidden" name="_token" :value="csrf">
            <input v-if="form.method=='patch'" type="hidden" name="_method" value="patch">

            <card-with-header class="card-cascade narrower mb-r">
                <header slot="header"
                        class="view gradient-card-header pt-3 pb-3 d-none d-md-block mb-3"
                        :class="{
                        'primary-color':(status == 'active' || status == true),
                        'disabled-color':(status != 'active' && status != true),
                    }"
                >
                    <div class="d-flex justify-content-between align-items-center">
                        <h4 class="mb-0 text-capitalize">{{crud}} coupon</h4>
                        <BaseButtonRound v-on:click.native="tooltip=!tooltip"
                                         title="Select to disable tips"
                                         :tooltip="true"
                                         :cls="{
                                        'ml-0 my-0 mr-1':tooltip,
                                        'ml-0 my-0 mr-1 disabled':!tooltip,
                                     }"
                                         type="div"
                                         :small="false"
                        >
                            <template slot="content">
                                <i class="material-icons">announcement</i>
                            </template>
                        </BaseButtonRound>
                    </div>
                    <hr>
                    <p class="mb-0">
                        Discount is applied to each qualifying item in the checkout basket. Thus preventing discounts on
                        items that do not apply e.g <strong>Season tickets</strong>
                    </p>
                </header>

                <!--status & Allocation-->

                <div class="row">
                    <!--status-->
                    <div class="col-12 col-md-6 d-flex" data-ref="wrapper">
                        <BaseSwitch
                                :tabindex="0"
                                class="w-100 align-self-center"
                                :checked="(status == 'active' || status == true)"
                                @input_value="statusModel"
                                field="status"
                                identifier="status"
                                label="Status"
                                switch_off="Off"
                                switch_on="active"
                                :title="notifier(`Coupon will be usable when active`,true)"
                                :tooltip="tooltip"
                        ></BaseSwitch>
                    </div>
                    <!--Allocation-->
                    <div class="col-12 col-md-6" data-ref="wrapper">
                        <BaseInputWithIcon
                                :tabindex="1"
                                class="my-md-0"
                                label="Allocation"
                                id="allocated"
                                field="allocated"
                                identifier="allocated"
                                input_type="number"
                                :required="false"
                                @input_value="AllocationModel"
                                title="Default unlimited by setting to zero or leaving blank"
                                :tooltip="tooltip"
                                icon="account_balance"
                                :value="allocated"
                                :error="false"
                        ></BaseInputWithIcon>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-lg-12">
                        <!--coupon name-->
                        <BaseInputWithIcon
                                :tabindex="2"
                                autocomplete="off"
                                label="Name"
                                id="coupon-id"
                                field="coupon_data->lang->en_GB->title"
                                identifier="title"
                                :required="true"
                                :value="title"
                                @input_value="titleModel"
                                title="Used to identify this coupon"
                                :tooltip="tooltip"

                                @form_error="setInputError"
                                :error="errors.title"
                        ></BaseInputWithIcon>
                    </div>
                    <div class="col-12 col-lg-12 mb-4">

                        <!--coupon code-->
                        <BaseCodeInput
                                :tabindex="3"
                                autocomplete="off"
                                placeholder="Voucher Code"
                                @input_value="codeModel"
                                @state_valid="codeValidModel"
                                @form_error="setInputError"
                                :error="errors.code"
                                identifier="code"

                                validate_text="Validate"
                                field="code"
                                :value="code"
                                :generate="true"
                                :title="notifier(`The code used to claim the discount`,true)"
                                :tooltip="tooltip"
                                :btn_refresh="true"
                                col_input="col-lg-6"
                                col_btn_wrapper="col-lg-6"
                                col_refresh="col-lg-4"
                                col_validate="col-lg-8"

                                :code_validate_url="url.code_validate"
                                :code_generate_url="url.code_generate"
                        ></BaseCodeInput>

                    </div>
                </div>

                <!--start date and expiry-->
                <div class="row">
                    <input type="hidden" name="start_date" :value="dates.start">
                    <input type="hidden" name="end_date" :value="dates.ends">
                    <!--coupon start-->
                    <div class="col-12 col-md-6">
                        <BaseDatePicker
                                :tabindex="4"
                                @input_value="dateStartSet"
                                :set_date="dates.start"
                                field="start_date_fn"
                                :set_active="true"
                                :set_now="true"
                                label="Available from"
                                :title="notifier(`The voucher will be available availble from...`,true)"
                                :tooltip="tooltip"
                        ></BaseDatePicker>
                    </div>
                    <!--coupon expiry-->
                    <div class="col-12 col-md-6" v-show="!date_on_going">
                        <BaseDatePicker
                                :tabindex="5"

                                @input_value="dateEndSet"
                                field="end_date_fn"
                                :set_date="dates.end"
                                :set_active="!date_on_going"
                                :set_now="true"
                                label="To"
                                :title="notifier(`If the day is the same as the start date,  it will expire at 1 second before midnight on the same day`,true)"
                                :tooltip="tooltip"
                        ></BaseDatePicker>
                    </div>
                </div>
                <!--date expires switcher-->
                <div class="row">
                    <div class="col-12">
                        <BaseSwitch
                                :tabindex="6"

                                field="local->ongoing"
                                switch_on="Is on going"
                                switch_off="Discount Expires"
                                :checked="date_on_going"
                                @input_value="dateOngoingModel"
                                :title="notifier(`Select dicsount expires to set an end date`,true)"
                                :tooltip="tooltip"
                        ></BaseSwitch>
                    </div>
                </div>
            </card-with-header>

            <!--assign to ticket/events/entity etc-->
            <card-basic cls="mb-5">
                <!--Allow coupons to season tickets-->
                <div class="row">
                    <div class="col-12 col-md-6">
                        <BaseSwitch
                                :tabindex="7"
                                :checked="season_ticket_allow"
                                @input_value="seasonTicketAllow"
                                field="coupon_data->allow_season_tickets"
                                label="Allow Season tickets?"
                                switch_off="nope"
                                switch_on="allowed"
                                :title="notifier(`You must be absolutely sure that you wish to allow coupons on season tickets`,'warning')"
                                :tooltip="tooltip"
                        ></BaseSwitch>
                    </div>
                    <div class="col-12 col-md-6">

                    </div>
                </div>

                <!--Assign to coupon type and id-->
                <div class="row">
                    <!--coupon type-->
                    <div class="col-12 col-md-6">

                        <material-select ref="coupon_assigned_to_select"
                                         id="coupon_assigned_to"
                                         @material_select_result="couponAssigned"
                                         title="Attention. If you choose All then everything in the checkout will qualify for the discount"
                                         :tooltip="tooltip"
                        ></material-select>
                    </div>
                    <!--coupon type id-->
                    <div class="col-12 col-md-6">
                        <div :id="wrappers.ticket.id"
                             :class="{
                            'd-none': wrappers.ticket.cls != true
                         }"
                        >
                            <material-select :tabindex="8"
                                             ref="coupon_tickets_select"
                                             id="coupon_tickets_select"
                                             title="Select tickets to be illegible for discount"
                                             @material_select_result="couponTicketsModel"
                            ></material-select>
                        </div>
                        <div :id="wrappers.entity.id"
                             :class="{
                            'd-none': wrappers.entity.cls != true
                         }">
                            <material-select :tabindex="9"
                                             ref="coupon_entities_select"
                                             id="coupon_entities_select"
                                             title="Warning. All tickets (excluding season tickets unless enabled) assigned to the selected entities will qualify for discount"
                                             @material_select_result="couponEntitiesModel"
                            ></material-select>
                        </div>
                        <div :id="wrappers.event.id"
                             :class="{
                            'd-none': wrappers.event.cls != true
                         }">
                            <material-select :tabindex="10"
                                             ref="coupon_events_select"
                                             id="coupon_events_select"
                                             title="Warning. All tickets (excluding season tickets unless enabled) assigned to the selected events will qualify for discount"
                                             :tooltip="tooltip"
                                             @material_select_result="couponEventsModel"
                            ></material-select>
                        </div>
                    </div>
                </div>

                <!--discount type selector and value-->
                <div data-ref="discount type selector and value" class="row">
                    <!--discount type-->
                    <div class="col-12 col-md-6">
                        <material-select :tabindex="11"
                                         ref="discount_type_select"
                                         id="discount_type"
                                         @material_select_result="discountType"
                                         title="If you choose All then everything in the checkout will qualify for the discount"
                                         :tooltip="tooltip"
                        ></material-select>
                    </div>
                    <!--discount value-->
                    <template v-if="!free_discount">
                        <div class="col-12 col-md-6">
                            <BaseInputWithIcon
                                    :tabindex="12"
                                    label="Discount Amount"
                                    id="discount_value"
                                    :value="discount_value"
                                    :error="errors.discount_value"
                                    identifier="discount_value"
                                    @form_error="setInputError"
                                    icon="card_membership"
                                    field="coupon_data->discount_value"
                                    :input_type="discount_type === 'price_reduction'?'money':'number'"
                                    @input_value="discountValueModel"
                                    title="Enter the value amount"
                                    :tooltip="tooltip"
                                    :novalidate="true"
                            ></BaseInputWithIcon>
                        </div>
                    </template>
                </div>

                <!--orders over && is stackable-->
               <div class="row">
                   <div class="col-12 col-md-6 d-flex">
                       <!--is stackable-->
                       <BaseSwitch
                               class="w-100 align-self-center"
                               field="coupon_data->stackable"
                               :tabindex="14"
                               switch_on="Not stackable"
                               switch_off="Discounts can stack"
                               :checked="true"
                               @input_value="statusModel"
                               :title="notifier(`Multiple vouchers can be used at the same time when allowed to stack`,'warning')"
                               :tooltip="tooltip"
                       ></BaseSwitch>
                   </div>
                   <div class="col-12 col-md-6">
                       <!--orders over-->
                       <BaseInputWithIcon
                               :tabindex="13"
                               label="On orders over"
                               class="my-md-0"
                               id="orders_over"
                               field="coupon_data->orders_over"
                               input_type="money"
                               :required="false"
                               @input_value="ordersOverModel"
                               title="The qualifying assignment will apply the discount if the total value exceeds this amount"
                               :tooltip="tooltip"
                               icon="monetization_on"
                               :value="(orders_over_pennies > 0)? orders_over_pennies / 100:0"
                       ></BaseInputWithIcon>
                   </div>
               </div>
            </card-basic>

            <div class="fixed-action-btn-est btn-floating---submit " style="bottom: 45px; right: 24px;">
                <a type="submit"
                   @click='submitForm()'
                   :class="{
                    'btn-disabled':!can_submit
                    }"
                   class="animated pulse waves-effect waves-light btn-floating btn-floating--single btn-lg border-0 "
                   id="coupon--save">
                    <i class="material-icons" aria-hidden="true">save</i>
                </a>

            </div>
        </form>
    </div>
</template>

<script>
	import axios from 'axios';
	import Vue from 'vue';
	import Vuex from 'vuex';
	import MaterialSelect from '../../forms/select/MaterialSelect.vue';

	import lang from '../../../../../../app/Shared/Resources/Assets/js/helpers/lang';
	import {
		getDate,
		getEndOfDay,
		DATE_FORMAT
	} from "../../../../../../app/Shared/Resources/Assets/js/helpers/format.date";
	import {_} from 'underscore';

	window.Vue.use(Vuex);
	/**
	 * @param   storeCoupon
	 * @param   storeCoupon.state
	 * @param   storeCoupon.mutations
	 * @param   storeCoupon.actions
	 * @param   storeCoupon.getters
	 *
	 * @type {Vuex.Store}
	 **/
	const storeCoupon = new Vuex.Store({
		state: {
			code: '',
			code_validated: false,
			discount_value: null,
			validated_code: '',
			url: {
				entities: '',
				events: '',
				tickets: '',
				code_validate: '',
				code_generate: '',
			},
			stuff: [],
			current: {
				tickets: [],
				entities: [],
				events: [],
			},
			selected: {
				tickets: [],
				entities: [],
				events: [],
			},
			date_picker: {
				start: {
					id: '',
					value: ''
				},
				end: {
					id: '',
					value: ''
				}
			},
			icon: {
				single: 'icon-flat-ticket',
				vip: 'icon-flat-vip-ticket',
				bulk: 'icon-flat-bulk-ticket',
				season: 'icon-flat-season-ticket',
				'vip-season': 'icon-flat-vip-season'
			},
			allow_season_tickets: true
		},
		mutations: {
			setDatePickerIds(state) {
				state.date_picker.start.id = _.uniqueId('start_date' + Date.now());
				state.date_picker.end.id = _.uniqueId('end_date' + Date.now());
			},
			url(state, urlData) {
				for (let key in urlData) {
					state.url[key] = urlData[key];
				}

			},
			SET_DISCOUNT_VALUE(state, value) {
				state.discount_value = value;
			},
			SET_SEASON_TICKET_STATE(state, value) {
				state.allow_season_tickets = value;
			},
			SET_CURRENT_DATA(state, {selected_type, response, data_preset_array}) {

				let items = [];
				for (let responseKey in response) {
					let record = response[responseKey];
					let data = {};
					let event_title = '';
					let entity_title = '';
					let start_date = 'TBA';

					switch (selected_type) {
						case 'tickets':

							let ticket_type = record.ticket_type;

							if (!state.allow_season_tickets && ticket_type === 'season') {
								continue;
							}

							let ticket_title = lang('title', record.ticket_data.lang);
							event_title = lang('title', record.events[0].lang);
							start_date = (record.events[0].start_date !== null) ? getDate(record.events[0].start_date, DATE_FORMAT.tiny) : 'TBA';
							data = {
								id: record.id,
								lang: {
									'en_GB': {
										title: `${ticket_title} (${event_title}) ${start_date}`
									}
								},
								icon_class: state.icon[record.ticket_type]
							};

							break;

						case 'entities':
							entity_title = lang('title', record.entity_data.lang);
							data = {
								id: record.id,
								lang: {
									'en_GB': {
										title: `[id:${record.id}] ${entity_title}`
									}
								}
							};
							break;

						case 'events':
							event_title = lang('title', record.event_data.lang);
							start_date = (record.start_date !== null) ? getDate(record.start_date, DATE_FORMAT.tiny) : 'TBA';

							data = {
								id: record.id,
								lang: {
									'en_GB': {
										title: `[id:${record.id}] ${event_title} ${start_date}`
									}
								}
							};
							break

					}
					if (record.id in state.selected[selected_type]) {
						items['selected'] = true;
					}
					// iterate through preset array
					for (let i = 0; i < data_preset_array.length; i++) {
						let dataPresetArrayElement = data_preset_array[i];
						if (dataPresetArrayElement === record.id) {
							data['selected'] = true;
						}
					}
					items.push(data);
					state.current[selected_type] = items;
				}

				return state.current[selected_type];
			},

			SET_CODE_GENERATED(state, code) {
				state.code = state.validated_code = code;
			},
			SET_VALIDATE_CODE(state, bool_response) {
				state.code_validated = bool_response;
			},
			REMOVE_ALL_SELECTED(state) {

				// iterate each type
				for (let currentKey in state.current) {
					let records = state.current[currentKey];

					for (let record in records) {
						delete record.selected;
					}
				}
			}
		},
		actions: {
			fetchApiData: ({commit, state}, selected_data) => {
				let data = {},
					selected_type = selected_data.type,
					data_preset_array = selected_data.data,
					url = state.url[selected_type];

				return axios
					.post(url, data)
					.then(r => r.data)
					.then(response => {
						commit('SET_CURRENT_DATA', {selected_type, response, data_preset_array});
						// return state.current[selected_type];
					})
					.catch(error => {
						console.error('error', error);
					});
			},

			fetchDatePickerIds({commit}) {
				commit('setDatePickerIds')
			}
		},
		getters: {
			entities: state => state.current.entities,
			events: state => state.current.events,
			tickets: state => state.current.tickets,
			code_validated: state => state.code_validated,
			discount_value: state => state.discount_value,
			code: state => state.code,
			start_date_id: state => state.date_picker.start.id,
			end_date_id: state => state.date_picker.end.id,

		}
	});
	Vue.component('card-with-header', require('../../cards/CardWithHeader'));
	Vue.component('card-basic', require('../../cards/CardBasic'));

	export default {
		name: "coupon-crud",
		components: {
			'material-select': MaterialSelect
		},
		props: {
			url: Object,
			form: Object,
			action_button: {
				type: String,
				default: 'coupon_save'
			},
			/**
			 * @param {Number} coupon.coupon_data.orders_over
			 * @param {Boolean} coupon.coupon_data.allow_season_tickets
			 * @param {Array} coupon.coupon_data.tickets_array
			 * @param {Array} coupon.coupon_data.events_array
			 * @param {Array} coupon.coupon_data.entities_array
			 * @param {Object} coupon.coupon_data
			 * @param {String} coupon.coupon_type
			 * @param {Object} coupon
			 * @namespace coupon
			 * */
			coupon: {
				type: Object,
				default: null
			},
			crud: {
				type: String,
				default: 'create'
			}
		},
		created() {
			if (this.coupon != null) {
				this.status = this.coupon.status;
				this.allocated = this.coupon.allocated;
				this.title = lang('title', this.coupon.coupon_data.lang);
				this.code = this.codeModel(this.coupon.code);
				this.codeValidModel(true);

				this.dates.start = this.coupon.start_date;
				this.dates.end = this.coupon.end_date;
				this.date_on_going = (this.dates.end == null);

				this.seasonTicketAllow(this.coupon.coupon_data.allow_season_tickets);

				this.coupon_assigned_to = this.coupon.coupon_type;
				this.coupon_assigned_to_types = this.initSelectComponentList(this.coupon_assigned_to_types, this.coupon_assigned_to);

				this.discount_types = this.initSelectComponentList(this.discount_types, this.coupon.coupon_data.discount_type);
                this.discount_type = this.coupon.coupon_data.discount_type;
				this.free_discount = this.coupon.coupon_data.discount_type === 'free';
				if(this.discount_type ==='price_reduction'){
                    this.discount_value = this.coupon.coupon_data.discount_value/100;
                }else{
                    this.discount_value = this.coupon.coupon_data.discount_value
                }
				storeCoupon.commit('SET_DISCOUNT_VALUE', this.discount_value);
				this.orders_over_pennies = this.coupon.coupon_data.orders_over * 100;
			}
			else {
				// assign default selected items to material selects
			}
		},
		destroyed() {
		},
		mounted() {
			let self = this;

			storeCoupon.dispatch('fetchDatePickerIds');
			//setup urls
			storeCoupon.commit('url', this.url);

			storeCoupon
				.dispatch('fetchApiData', {
					type: 'tickets',
					data: (this.coupon != null) ? this.coupon.coupon_data.tickets_array : []
				})
				.then(function () {
					if (self.coupon != null) {
						if (self.coupon.coupon_data.tickets_array.length > 0) {
							self.wrappers.ticket.cls = true;
							self.initTicketsMaterialSelect([]);
						}
					}
				});

			storeCoupon
				.dispatch('fetchApiData', {
					type: 'events',
					data: (this.coupon != null) ? this.coupon.coupon_data.events_array : []
				})
				.then(function () {
					if (self.coupon != null) {
						if (self.coupon.coupon_data.events_array.length > 0) {
							self.wrappers.event.cls = true;
							self.initEventsMaterialSelect([]);
						}
					}
				});

			storeCoupon
				.dispatch('fetchApiData', {
					type: 'entities',
					data: (this.coupon != null) ? this.coupon.coupon_data.entities_array : []
				})
				.then(function () {
					if (self.coupon != null) {
						if (self.coupon.coupon_data.entities_array.length > 0) {
							self.wrappers.entity.cls = true;
							self.initEntitiesMaterialSelect([]);
						}
					}
				});

			this.initCouponAssignedToMaterialSelect([]);
			this.initDiscountTypeMaterialSelect([]);
		},
		data() {
			return {
				csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
				can_submit: false,
				tooltip: true,
				tabindex: 0,

				code: '',
				title: '',

				errors: {
					title: false,
					code: false,
                    discount_value:false
				},

				status: true,
				allocated: null,
				free_discount: false,
				assign_to_all_types: true,
                /**
                 * @param {string} discount_type
                 * */
				discount_type: '',
				discount_value: 0,
				orders_over_pennies: 0,
				date_on_going: true,
				material_select: {
					ticket: {
						params: {
							multiple: true,
							grouped: [],
							group_by: '',
							top_option: {
								title: 'Choose tickets'
							},
							selected_input_name: 'coupon_data->tickets_array[]',
							label: 'Choose one or more tickets',
							placeholder: '',
							id: 'tickets_select_id',
							link: {
								add: false
							}
						}
					},
					entity: {
						params: {
							multiple: true,
							grouped: [],
							group_by: '',
							top_option: {
								title: 'Choose entities'
							},
							selected_input_name: 'coupon_data->entities_array[]',
							label: 'Choose one or more entities',
							placeholder: '',
							id: 'entities_select_id',
							link: {
								add: false
							}
						},
					},
					event: {
						params: {
							multiple: true,
							grouped: [],
							group_by: '',
							top_option: {
								title: 'Choose events'
							},
							selected_input_name: 'coupon_data->events_array[]',
							label: 'Choose one or more events',
							placeholder: '',
							id: 'events_select_id',
							link: {
								add: false
							}
						}
					},
				},
				dates: {
					start: null,
					ends: null
				},
				coupon_assigned_to: 'all',
				/**
				 * all, ticket, entity, event
				 */
				coupon_assigned_to_types: [
					{
						id: 'all',
						lang: '{"en_GB": {"title": "All", "description": {"long": null, "short": "All"}}}',
						selected: true
					},
					{
						id: 'ticket',
						lang: '{"en_GB": {"title": "Tickets", "description": {"long": null, "short": "Tickets"}}}'
					},
					{
						id: 'event',
						lang: '{"en_GB": {"title": "Events", "description": {"long": null, "short": "Events"}}}'
					},
					{
						id: 'entity',
						lang: '{"en_GB": {"title": "Entities", "description": {"long": null, "short": "Entities"}}}'
					}
				],
				/**
				 * free, percentage, reduction
				 */
				discount_types: [
					{
						id: 'free',
						lang: '{"en_GB": {"title": "Free", "description": {"long": null, "short": "free"}}}'
					},
					{
						id: 'percentage',
						lang: '{"en_GB": {"title": "Percentage", "description": {"long": null, "short": "percentage"}}}',
						selected: true
					},
					{
						id: 'price_reduction',
						lang: '{"en_GB": {"title": "Amount", "description": {"long": null, "short": "amount"}}}'
					}
				],
				season_ticket_allow: false,
				wrappers: {
					ticket: {
						id: 'coupon_tickets_select--wrapper',
						cls: false
					},
					event: {
						id: 'coupon_events_select--wrapper',
						cls: false
					},
					entity: {
						id: 'coupon_entities_select--wrapper',
						cls: false
					},
				},
				assignment: {
					entities: [],
					events: [],
					tickets: [],
				},
			}
		},
		methods: {
			setInputError(e) {
			    // console.log('input error',e)
				this.errors[e.id] = e.value;
			},
			submitForm() {
				this.$refs.coupon_form.addEventListener('submit', event => {
					event.preventDefault()
				});
				this.can_submit = true;
				if (!this.title) {
					this.can_submit = false;
					this.errors.title = true;
				}
				if (!storeCoupon.getters.discount_value) {
					this.can_submit = false;
					this.errors.discount_value = true;
					// console.log('discount value')
				}
				if (!storeCoupon.getters.code || !storeCoupon.getters.code_validated) {
					this.can_submit = false;
					this.errors.code = true;
				}


				if (this.can_submit) {
					this.$refs.coupon_form.submit();
				}
			},
			initSelectComponentList(select_list, id_list) {

				// convert id_list to array if set as string
				if (!id_list.isArray) {
					id_list = [id_list];
				}

				let tmp = [];

				// iterate each row
				for (let selectListKey in select_list) {
					// get the row
					let selectListElement = select_list[selectListKey];

					// remove the selected element from the default so we can ovrride which one
					delete selectListElement.selected;
					// iterate the id list and set the row as selected if id is present
					for (let selectListIdKey in id_list) {

						if (selectListElement.id == id_list[selectListIdKey]
							|| selectListElement.id == id_list[selectListIdKey] + 's') {

							selectListElement['selected'] = true;
						}
					}
					tmp.push(selectListElement);
				}
				return tmp;
			},
			/**
			 * Tooltips title formatter
			 * @param str
			 * @param type the notification type e.g. warning,info
			 */
			notifier(str, type) {
				if (!str) {
					return;
				}
				let theType = type == 'warning' ? 'warning' : 'info';

				return `
<div class="row">
    <div class="col-12 col-4">
        <i class="material-icons">${theType}</i>
    </div>
    <div class="col-12 col-8">${str}</div>
</div>
`

			},

			/**
			 * Returns switch option
			 * @param on_going
			 **/
			dateOngoingModel(on_going) {
				this.date_on_going = on_going;

				// clear the end date if on going
				if (on_going) {
					this.dates.ends = '';
				}
			},

			/**
			 * Returns date
			 * @param date_object
			 **/
			dateStartSet(date_object) {
				this.dates.start = getDate(date_object, DATE_FORMAT.data_base);
			},

			/**
			 * Returns date
			 * @param date_object
			 **/
			dateEndSet(date_object) {

				this.dates.ends = getDate(date_object, DATE_FORMAT.data_base);

				// if the date is the same time then it ends at the end of that day
				if (this.dates.ends == this.dates.start) {
					this.dates.ends = getEndOfDay(this.dates.ends, DATE_FORMAT.data_base);
				}
			},

			/**
			 * Coupon type selector
			 */
			initCouponAssignedToMaterialSelect() {
				let self = this;
				/**
				 * @param self
				 * @param self.$refs
				 * @param self.$refs.coupon_assigned_to_select
				 * @type {default.methods}
				 */
				self.$refs.coupon_assigned_to_select.updateMenu({
					params: {
						multiple: false,
						grouped: [],
						group_by: '',
						top_option: {
							title: 'Assign coupon to'
						},
						selected_input_name: 'coupon_assigned_to',
						label: 'Assign to',
						placeholder: '',
						id: 'coupon_assigned_to_id',
						link: {
							add: false
						}
					},
					select_items: this.coupon_assigned_to_types
				});
			},

			/**
			 * Tickets selector
			 */
			initTicketsMaterialSelect() {
				let self = this;
				/**
				 * @param this
				 * @param this.$refs
				 * @param this.$refs.coupon_tickets_select
				 * @type {default.methods}
				 */
				this.$refs.coupon_tickets_select.updateMenu({
					params: self.material_select.ticket.params,
					select_items: storeCoupon.getters.tickets
				});
			},

			/**
			 * Entities selector
			 */
			initEntitiesMaterialSelect() {
				let self = this;

				/**
				 * @param this
				 * @param this.$refs
				 * @param this.$refs.coupon_entities_select
				 * @type {default.methods}
				 */
				this.$refs.coupon_entities_select.updateMenu({
					params: self.material_select.entity.params,
					select_items: storeCoupon.getters.entities
				});
			},

			/**
			 * Events selector
			 */
			initEventsMaterialSelect() {
				let self = this;

				/**
				 * @param this
				 * @param this.$refs
				 * @param this.$refs.coupon_events_select
				 * @type {default.methods}
				 */
				this.$refs.coupon_events_select.updateMenu({
					params: self.material_select.event.params,
					select_items: storeCoupon.getters.events
				});
			},

			/**
			 * Discount type selector amount / percentage
			 * @param groups
			 */
			initDiscountTypeMaterialSelect(groups) {
				/**
				 * @param self
				 * @param self.$refs
				 * @param self.$refs.discount_type_select
				 * @type {default.methods}
				 */
				this.$refs.discount_type_select.updateMenu({
					params: {
						multiple: false,
						grouped: groups,
						group_by: '',
						top_option: {
							title: 'Discount Type'
						},
						selected_input_name: 'coupon_data->discount_type',
						label: 'Discount Type',
						placeholder: '',
						id: 'ticket_chooser_id',
						link: {
							add: false
						}
					},
					select_items: this.discount_types
				});
			},

			/**
			 * The allocation model
			 */
			AllocationModel(num) {
				this.allocated = num;
			},

			/**
			 * receives order over value
			 */
			ordersOverModel(num) {
				this.orders_over_pennies = num * 100;
			},

			removeAllAssigned() {
				this.assignment = {
					entities: [],
					events: [],
					tickets: [],
				};
				storeCoupon.commit('REMOVE_ALL_SELECTED');
			},

			assignCouponSelectedToData(assigned_items, type) {
				this.removeAllAssigned();
				let assignmentType = type;

				for (let i = 0; i < assigned_items.length; i++) {
					let assignedItem = assigned_items[i],
						value = assignedItem.optionValue;

					if (this.$data.assignment[assignmentType].indexOf(value) == -1) {
						this.$data.assignment[assignmentType].push(value);
					}
				}
			},

			couponTicketsModel(assigned_items) {
				this.assignCouponSelectedToData(assigned_items, 'tickets');
			},
			couponEventsModel(assigned_items) {
				this.assignCouponSelectedToData(assigned_items, 'events');

			},
			couponEntitiesModel(assigned_items) {
				this.assignCouponSelectedToData(assigned_items, 'entities');
			},

			/**
			 * Selected Assignment of coupon. Will initialise the relevant material selector
			 * @param x The selected type
			 * @default all
			 */
			couponAssigned(x) {
				// hide all selectors first then un hide the selected one
				this.wrappers.ticket.cls
					= this.wrappers.entity.cls
					= this.wrappers.event.cls
					= false;

				if (typeof x[0] !== 'undefined' && x[0] !== null) {
					let selected = x[0].optionValue;

					this.assign_to_all_types = false;
					this.coupon_assigned_to = selected;
					this.removeAllAssigned();
					if (selected == 'ticket') {
						this.initTicketsMaterialSelect();
					}
					else if (selected == 'entity') {
						this.initEntitiesMaterialSelect();
					}
					else if (selected == 'event') {
						this.initEventsMaterialSelect();
					}

					/**
					 * If selected is not all then show the selected material select
					 */
					if (selected != 'all') {
						this.wrappers[selected].cls = true;
					}
					else {
						this.assign_to_all_types = true;
						this.coupon_assigned_to = 'all';
					}
				}
			},

			/**
			 * Applies the value: percentage or amount and also sets free
			 * @param x
			 */
			discountType(x) {
				if (typeof x[0] !== 'undefined' && x[0] !== null) {

					this.discount_type = x[0].optionValue;

					this.free_discount = x[0].optionValue === 'free';
				}
			},
			titleModel(x) {
				this.title = x;
			},
			codeModel(x) {
				this.code = x;
				storeCoupon.commit('SET_CODE_GENERATED', this.code);
				return storeCoupon.getters.code;
			},
			codeValidModel(x) {
				storeCoupon.commit('SET_VALIDATE_CODE', x);
			},
			seasonTicketAllow(x) {
				this.season_ticket_allow = x;
				storeCoupon.commit('SET_SEASON_TICKET_STATE', this.season_ticket_allow);
			},
			statusModel(x) {
				this.status = (x) ? 'active' : 'inactive';
			},
			discountValueModel(num) {
				// this.discount_value = num * 100;
				storeCoupon.commit('SET_DISCOUNT_VALUE', num);
			},
		},
		watch: {},
		computed: {}
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/pages/coupons/CouponCRUD.vue?2257eda8